import { post, get } from '@/utils/request'
import type {
  SalesLoginForm,
  SalesInfo,
  WechatQrCodeResponse,
  WechatLoginStatusResponse,
} from '@/store/modules/sales'

/**
 * 销售人员相关API接口
 */

/**
 * 销售人员登录
 * @param loginForm 登录表单数据（用户名和密码）
 * @returns Promise<SalesInfo> 返回销售人员信息
 */
export function salesLogin(loginForm: SalesLoginForm): Promise<SalesInfo> {
  return post<SalesInfo>('/system/auth/login', loginForm)
}

/**
 * 生成微信登录二维码
 * @returns Promise<WechatQrCodeResponse> 返回二维码URL和场景值
 */
export function generateWechatQrCode(): Promise<WechatQrCodeResponse> {
  return post<WechatQrCodeResponse>('/wechat/generate-qrcode')
}

/**
 * 检查微信登录状态
 * @param scene 二维码场景值
 * @returns Promise<WechatLoginStatusResponse> 返回登录状态
 */
export function checkWechatLoginStatus(scene: string): Promise<WechatLoginStatusResponse> {
  return get<WechatLoginStatusResponse>(`/wechat/check-login-status?scene=${scene}`)
}

/**
 * 销售人员登出
 * @returns Promise<void>
 */
export function salesLogout(): Promise<void> {
  return post<void>('/sales/logout')
}

/**
 * 获取销售人员信息
 * @returns Promise<SalesInfo> 返回销售人员详细信息
 */
export function getSalesInfo(): Promise<SalesInfo> {
  return get<SalesInfo>('/sales/info')
}
